<script setup>
/**
 * The html structure of the ElSelect component makes testing very difficult, because there's no
 * easy way to find the component by placeholder or display value - both are rendered the same way
 * in the dom.
 * Also, when there's a value selected, the placeholder is not rendered at all.
 *
 * To work around this, we are binding our own custom `data-placeholder` prop, which will be used
 * by custom testing-library queries to find the right component.
 */

// Import under an alias to avoid potential recursive rendering of the same component
import { ElSelect as ElementPlusSelect } from 'element-plus'
import { ref } from 'vue'

const selectRef = ref()

defineExpose({
  focus: () => selectRef.value?.focus(),
  blur: () => selectRef.value?.blur(),
  toggleMenu: () => selectRef.value?.toggleMenu?.()
})
</script>

<template>
  <element-plus-select ref="selectRef" :data-placeholder="$attrs.placeholder">
    <template v-for="(_, name) in $slots" #[name]="data">
      <slot :name="name" v-bind="data || {}" />
    </template>
  </element-plus-select>
</template>
